import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["contentAsSectionElement"];
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useQuickViewContainer } from "@jutro/quick-view";
import { useTranslator } from "@jutro/locale";
import styles from "./AppFloorPlan.module.css";
import { messages } from "./AppFloorPlan.messages";
PropTypes.node, PropTypes.string, PropTypes.node, PropTypes.node, PropTypes.node, PropTypes.node, PropTypes.bool, PropTypes.string, PropTypes.string, PropTypes.bool;
var Content = function (_ref) {
    var contentAsSectionElement = _ref.contentAsSectionElement,
      rest = _objectWithoutProperties(_ref, _excluded);
    return contentAsSectionElement ? React.createElement("section", rest) : React.createElement("main", rest);
  },
  AppFloorPlanLayout = function (props) {
    var _cx2,
      translator = useTranslator(),
      quickViewContainerRef = useQuickViewContainer(),
      rightSide = props.rightSide,
      children = props.children,
      className = props.className,
      footer = props.footer,
      header = props.header,
      subHeader = props.subHeader,
      leftSide = props.leftSide,
      scrollContent = props.scrollContent,
      contentLayout = props.contentLayout,
      contentClassName = props.contentClassName,
      contentAsSectionElement = props.contentAsSectionElement,
      floorPlanClasses = cx(styles.floorPlan, _defineProperty({}, styles.scrollContent, scrollContent), className),
      marginLayout = contentLayout ? styles[contentLayout] : styles.default;
    return React.createElement("div", {
      className: floorPlanClasses,
      "data-testid": "floorplan-layout"
    }, header, subHeader, React.createElement("div", {
      className: styles.content,
      ref: quickViewContainerRef
    }, leftSide && React.createElement("nav", {
      className: styles.leftSide,
      "aria-label": translator(messages.sideNavTitle)
    }, leftSide), React.createElement(Content, {
      contentAsSectionElement: contentAsSectionElement,
      className: cx(styles.mainContent, contentClassName, marginLayout, (_cx2 = {}, _defineProperty(_cx2, styles.leftNav, leftSide), _defineProperty(_cx2, styles.rightNav, rightSide), _cx2)),
      tabIndex: scrollContent ? 0 : -1
    }, children), rightSide && React.createElement("aside", {
      className: styles.rightSide
    }, rightSide)), footer);
  };
AppFloorPlanLayout.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanLayout"
};
export default AppFloorPlanLayout;
Content.__docgenInfo = {
  componentName: "Content",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "Content",
  methods: [],
  actualName: "Content"
}, AppFloorPlanLayout.__docgenInfo = {
  componentName: "AppFloorPlanLayout",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanLayout",
  methods: [],
  actualName: "AppFloorPlanLayout"
};